
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetokashidbeach() {



    const cardData =
    {
        keyword: 'Pune to Kashid Beach Cab',
        heading: 'Meghana Cab : Pune to Kashid Beach Cab',
        headingDescription: 'Meghana Cab offers Pune to Kashid Beach Cab services, making your coastal getaway smooth, comfortable, and enjoyable. Whether you’re planning a weekend escape, a beach holiday, or a family trip, our clean and spacious cabs with expert drivers ensure a safe and relaxed journey. Enjoy scenic views on the way, on-time pickups, affordable rates, and 24/7 customer support. Book your Pune to Kashid Beach Cab with Meghana Cab and soak in the sun, sea, and serenity with complete peace of mind.',


        top: 'Top Places to Visit in Kashid Beach with Meghana Cab',

"topPlaces": [
  {
    "title": "Kashid Beach",
    "description": "A pristine white-sand stretch along the Arabian Sea, backed by swaying Casuarina groves. Ideal for sunbathing, beach walks, hammocks, and casual picnics. During Oct–Feb, you can enjoy jet-ski, parasailing, banana-boat rides, horse-riding, snorkeling, and even night camping beside a bonfire under starlit skies.🌅 :contentReference[oaicite:2]{index=2}"
  },
  {
    "title": "Phansad Wildlife Sanctuary",
    "description": "Just ~12 km inland, this sanctuary spans coastal forest and grasslands. Home to leopards, deer, Indian giant squirrels, and over 150 bird species. With several walking trails, it’s a peaceful nature escape and excellent for birdwatching and light trekking. 🦌 :contentReference[oaicite:3]{index=3}"
  },
  {
    "title": "Korlai Fort",
    "description": "A 16th-century Portuguese fort perched on a hill overlooking Kashid’s shoreline. Featuring rugged ramparts, an old lighthouse, and ocean vistas, this atmospheric ruin is about 11 km away—perfect for a historical excursion and coastal photography. 📸 :contentReference[oaicite:4]{index=4}"
  },
  {
    "title": "Revdanda Beach & Fort",
    "description": "Approximately 3 km south, this lesser-known spot offers tranquil beach stretches beside partially overgrown Portuguese-era fort ruins. A peaceful place for solitude, ruins exploration, and absorbing coastal history. 🏰 :contentReference[oaicite:5]{index=5}"
  },
  {
    "title": "Murud‑Janjira Fort",
    "description": "Around 20 km away, this magnificent 15th-century marine fort sits offshore and is accessible by boat. Its 26 intact bastions, impressive gateways, freshwater tanks, and cannons make it a compelling maritime-historic site. ⚓ :contentReference[oaicite:6]{index=6}"
  },
  {
    "title": "Padmadurg Fort",
    "description": "A small island fort built by Shivaji near Kashid, reached by boat from Murud. Once a strategic defense against Janjira, today it’s an atmospheric ruin rising from the sea—great for history lovers and photography. 🏝️ :contentReference[oaicite:7]{index=7}"
  },
  {
    "title": "Kashid Buddhist Caves",
    "description": "Located on either end of the beach, these small ancient rock-cut Buddhist shrines add cultural depth. Quiet and evocative, they offer a glimpse into early trade-route archaeology alongside shoreline serenity. 🕉️ :contentReference[oaicite:8]{index=8}"
  },
  {
    "title": "Nearby Beaches: Nagaon & Akshi",
    "description": "Just 15–20 km away, Nagaon and Akshi beaches offer calm waves, local fishing scenes, and fewer crowds—perfect for swimming and quiet beach strolls away from the tourist spots. 🏖️ :contentReference[oaicite:9]{index=9}"
  },
  {
    "title": "Shopping & Local Market",
    "description": "The local Kashid bazaar features seashell crafts, wooden souvenirs, and cashew or coconut-based handicrafts. Great place to pick up mementos and taste local crunchy snacks. 🛍️ :contentReference[oaicite:10]{index=10}"
  },
  {
    "title": "Water‑Sports & Camping",
    "description": "Modest adventure meets serene nights—try jet-skiing, banana boats, scuba-diving, or parasailing, then camp overnight along the beach in tents, sharing stories by the fire under the Milky Way. 🎇 :contentReference[oaicite:11]{index=11}"
  }
],

"services": [
    {
        "name": "Pune to Kashid Beach Cab Hire",
        "description": "Hire comfortable and reliable cabs from Pune to Kashid Beach with Meghana Cab. Enjoy a scenic and safe ride to this beautiful coastal destination with our professional drivers."
    },
    {
        "name": "Book Taxi for Kashid Beach from Pune",
        "description": "Easily book a taxi from Pune to Kashid Beach with Meghana Cab. Our hassle-free booking process ensures a smooth start to your beach trip."
    },
    {
        "name": "One Way Cab Pune to Kashid",
        "description": "Travel one way from Pune to Kashid Beach with Meghana Cab’s timely and affordable taxi service, perfect for spontaneous trips and beach day outings."
    },
    {
        "name": "Pune to Kashid Beach Weekend Cab",
        "description": "Plan your weekend getaway to Kashid Beach with Meghana Cab. Our weekend cab services offer comfort and flexibility to make your trip memorable."
    },
    {
        "name": "Budget Cabs to Kashid from Pune",
        "description": "Looking for affordable cabs from Pune to Kashid Beach? Meghana Cab provides budget-friendly rides without compromising on service or comfort."
    },
    {
        "name": "AC Taxi Pune to Kashid",
        "description": "Travel comfortably with Meghana Cab’s air-conditioned taxis from Pune to Kashid Beach, ensuring a cool and pleasant journey."
    },
    {
        "name": "SUV Cab Pune to Kashid Beach",
        "description": "Book spacious and powerful SUV cabs for your Pune to Kashid Beach trip. Ideal for families and groups requiring extra space and luggage capacity."
    },
    {
        "name": "Round Trip Pune to Kashid Cab",
        "description": "Enjoy the convenience of round trip taxi services from Pune to Kashid Beach with Meghana Cab, making your travel flexible and hassle-free."
    },
    {
        "name": "Book Pune to Kashid Online Cab",
        "description": "Use Meghana Cab’s online platform to book your Pune to Kashid Beach cab quickly and securely, with instant confirmation and professional service."
    },
    {
        "name": "Pune to Kashid Trip by Car",
        "description": "Experience a comfortable and safe trip by car from Pune to Kashid Beach with Meghana Cab’s well-maintained vehicles and skilled drivers."
    },
    {
        "name": "Private Cab Pune to Kashid Beach",
        "description": "Hire private cabs from Pune to Kashid Beach for exclusive and personalized travel, perfect for couples, families, and small groups."
    },
    {
        "name": "Family Cabs to Kashid from Pune",
        "description": "Travel comfortably with your family to Kashid Beach from Pune with Meghana Cab’s family-friendly cabs, ensuring safety and convenience."
    },
    {
        "name": "Pune to Kashid Taxi Fare Estimate",
        "description": "Get transparent fare estimates for your Pune to Kashid Beach trip with Meghana Cab, helping you plan your travel budget effectively."
    },
    {
        "name": "Affordable Ride Pune to Kashid",
        "description": "Choose Meghana Cab for affordable and reliable rides from Pune to Kashid Beach, ensuring great value and quality service."
    },
    {
        "name": "Travel Cab to Kashid from Pune",
        "description": "Book your travel cab from Pune to Kashid Beach with Meghana Cab for a smooth, safe, and enjoyable journey to this scenic destination."
    }
],

"tableData": [
    ["Pune to Kashid Beach Cab Hire", "Book Taxi for Kashid Beach from Pune"],
    ["One Way Cab Pune to Kashid", "Pune to Kashid Beach Weekend Cab"],
    ["Budget Cabs to Kashid from Pune", "AC Taxi Pune to Kashid"],
    ["SUV Cab Pune to Kashid Beach", "Round Trip Pune to Kashid Cab"],
    ["Book Pune to Kashid Online Cab", "Pune to Kashid Trip by Car"],
    ["Private Cab Pune to Kashid Beach", "Family Cabs to Kashid from Pune"],
    ["Pune to Kashid Taxi Fare Estimate", "Affordable Ride Pune to Kashid"],
    ["Travel Cab to Kashid from Pune", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Relaxing Pune to Kashid Beach Cab Service",
        "WhyChoosedescription": "Meghana Cab offers a smooth and scenic cab ride from Pune to Kashid Beach. Whether you're planning a weekend retreat or a beach day with friends and family, enjoy a stress-free journey in our comfortable cabs."
    },
    {
        "WhyChooseheading": "On-Time Pick-Up and Drop-Off",
        "WhyChoosedescription": "We value your time. Our Pune to Kashid Beach cab service ensures punctual pick-up and drop-off so you can make the most of your beach trip without worrying about delays."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Coastal Routes",
        "WhyChoosedescription": "Our drivers are well-versed with the Pune to Kashid Beach route, including scenic stopovers and the safest coastal roads. Enjoy a safe and enjoyable ride through the picturesque terrain."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Meghana Cab offers budget-friendly Pune to Kashid Beach cab fares with no hidden costs. Get transparent pricing and full value for money with every trip."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Cabs for a Safe Journey",
        "WhyChoosedescription": "All our vehicles are thoroughly cleaned and sanitized before every trip. Enjoy a safe, hygienic ride with modern features like air conditioning, seat belts, and GPS tracking."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability to Kashid Beach",
        "WhyChoosedescription": "Whether you’re heading out at dawn or returning late at night, Meghana Cab offers round-the-clock service for your Pune to Kashid Beach travel needs."
    },
    {
        "WhyChooseheading": "Customizable Travel Plans and Stopovers",
        "WhyChoosedescription": "Want to explore en route spots like Alibaug or Murud? We offer flexible travel plans that allow stopovers and customized itineraries to enhance your beach getaway experience."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Customer Support",
        "WhyChoosedescription": "Booking your Pune to Kashid Beach cab is quick and easy with Meghana Cab. Use our website or mobile app, or contact our responsive support team for any travel assistance."
    }
]
























    }

const faqData = [
    {
        question: "How can I book a Pune to Kashid Beach cab with Meghana Cab?",
        answer: "Booking a Pune to Kashid Beach cab is simple with Meghana Cab. You can book online on our website or call us directly at +91 9075462128."
    },
    {
        question: "What types of cabs are available for Pune to Kashid Beach trips?",
        answer: "We offer hatchbacks, sedans, SUVs, and tempo travellers to suit your group size and comfort preferences."
    },
    {
        question: "How long does it take to travel from Pune to Kashid Beach by cab?",
        answer: "The journey from Pune to Kashid Beach usually takes around 3 to 4 hours, depending on traffic and road conditions."
    },
    {
        question: "Is one-way cab service available from Pune to Kashid Beach?",
        answer: "Yes, Meghana Cab provides both one-way and round-trip cab services for Pune to Kashid Beach travel."
    },
    {
        question: "Are tolls and parking charges included in the cab fare?",
        answer: "Toll and parking fees are additional and will be clearly communicated during the booking process."
    },
    {
        question: "Are your drivers experienced with the Pune to Kashid Beach route?",
        answer: "Yes, our drivers are professional and familiar with the Pune to Kashid Beach route to ensure a safe and comfortable journey."
    },
    {
        question: "Can I request stops during the Pune to Kashid Beach trip?",
        answer: "Yes, you can request stops along the way. Please inform us while booking so we can accommodate your needs."
    },
    {
        question: "Is the Pune to Kashid Beach cab service available 24/7?",
        answer: "Absolutely. Meghana Cab operates 24/7, allowing you to book a cab at any time."
    },
    {
        question: "What payment methods are accepted for Pune to Kashid Beach bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments for your convenience."
    },
    {
        question: "How can I contact Meghana Cab to book a Pune to Kashid Beach cab?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and assistance."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Vikram Desai',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our Pune to Kashid Beach trip with Meghana Cab was fantastic. The driver was punctual and the vehicle was very comfortable.”',
    },
    {
        name: 'Ms. Rina Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I highly recommend Meghana Cab for trips to Kashid Beach. The booking was easy, and the service was excellent.”',
    },
];


















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Kashid Beach Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-kashid-beach-cab.jpg",
  "description": "Book Pune to Kashid Beach cab with Meghana Cabs for one-way and round trips. Affordable AC, SUV, and private cabs available for weekend trips, family outings, and sightseeing.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5221"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-kashid-beach-cab"
  }
};








    return (
        <div>

<Helmet>
  <title>Pune to Kashid Beach Cab | Affordable & Reliable | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Kashid Beach cab with Meghana Cabs for one-way and round trips. Affordable AC, SUV, and private cabs available for weekend trips, family outings, and sightseeing." 
  />
  <meta 
    name="keywords" 
    content="Pune to Kashid Beach Cab Hire, Book Taxi for Kashid Beach from Pune, One Way Cab Pune to Kashid, Pune to Kashid Beach Weekend Cab, Budget Cabs to Kashid from Pune, AC Taxi Pune to Kashid, SUV Cab Pune to Kashid Beach, Round Trip Pune to Kashid Cab, Book Pune to Kashid Online Cab, Pune to Kashid Trip by Car, Private Cab Pune to Kashid Beach, Family Cabs to Kashid from Pune, Pune to Kashid Taxi Fare Estimate, Affordable Ride Pune to Kashid, Travel Cab to Kashid from Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/12.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetokashidbeach;